module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: _vm.height ? _vm.px(_vm.height) : '100%',
      width: _vm.width ? _vm.px(_vm.width) : '100%'
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4b81720"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aviasim/engine/ACE.vue
// module id = 306
// module chunks = 3